import React, { useEffect, useRef } from 'react';
import { Dating } from '@eventbrite/eds-iconography';
import styles from './DatingTouchpoint.module.scss';
import { Typography } from '@eventbrite/marmalade';
import { track } from '@eventbrite/datalayer-library';
import {
    DATING_DESCRIPTION,
    DATING_TITLE,
    DATING_BASE_URL,
    DATING_BUTTONS,
    DATING_COLLECTION_TO_SLUG_MAPPING,
} from '../../constants';

export const DatingTouchpoint = (props) => {
    const { collectionId } = props;
    const ref = useRef(null);

    useEffect(() => {
        const currentRef = ref.current;

        const observer = new IntersectionObserver(
            ([entry], observer) => {
                if (entry.isIntersecting) {
                    track({
                        eventName: 'UserCollectionComponentView',
                        eventData: {
                            eventBucketLabel: 'itsADate-Touchpoint',
                        },
                    });
                    observer.disconnect();
                }
            },
            {
                threshold: 0.7,
            },
        );

        if (currentRef) {
            observer.observe(currentRef);
        }

        return () => {
            if (currentRef) {
                observer.disconnect();
            }
        };
    }, []);

    if (
        !Object.hasOwnProperty.call(
            DATING_COLLECTION_TO_SLUG_MAPPING,
            collectionId,
        )
    ) {
        return null;
    }

    const DATING_BASE_URL = `/b/${DATING_COLLECTION_TO_SLUG_MAPPING[collectionId]}/home-and-lifestyle/dating/?category=`;

    return (
        <div
            ref={ref}
            className={styles.touchpoint}
            data-event-bucket-label="itsADate-Touchpoint"
        >
            <Dating />
            <div className={styles.details}>
                <Typography className={styles.title} variant="heading-sm">
                    {DATING_TITLE}
                </Typography>
                <Typography className={styles.description} variant="body-md">
                    {DATING_DESCRIPTION}
                </Typography>
            </div>
            <div className={styles.buttons}>
                {DATING_BUTTONS.map((button, index) => {
                    const ctaLink = `${DATING_BASE_URL}${button.category}`;
                    return (
                        <a
                            key={index}
                            className={styles.button}
                            href={ctaLink}
                            data-heap-id={`matchmakerMariaCollection-itsADate-${button.category}`}
                        >
                            <Typography
                                className={styles.buttonTypo}
                                variant="body-md-bold"
                            >
                                {button.title}
                            </Typography>
                        </a>
                    );
                })}
            </div>
        </div>
    );
};
